@if (selectedAccount?.currency === 'EUR' || isWorkflow) {
<finxone-web-frontend-intl-beneficiary-address
  [editBeneficiarySepa]="editBeneficiarySepa"
  [formActionData]="formActionStateData"
  (handleAddressChange)="valueChanges($event)"
>
</finxone-web-frontend-intl-beneficiary-address>
}
